import { useTranslation } from "react-i18next";
import styles from "./style.module.scss";
const PrivacyPolicy = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.pageTitle}>{t("normal.privacyPolicy")}</div>
        <div
          dangerouslySetInnerHTML={{
            __html: t("2esim.privacyPolicy.content", {
              brand: process.env.REACT_APP_PROD_NAME_DEV,
            }),
          }}
        />
      </div>
    </div>
  );
};

export default PrivacyPolicy;
